import { InstanceRole } from "./InstanceRole.interface";

// flattened structure of a product instance
export class ProductInstance {
    constructor({
        genAIEnabled = false,
        instanceId,
        instanceName,
        navigationUrl,
        nickname,
        optiIdEnabled,
        productId,
        productName,
        region = "N/A",
        roles,
        technicalContactEmail,
        technicalContactName
    }: {
        genAIEnabled?: boolean;
        instanceId: string;
        instanceName: string;
        navigationUrl?: string;
        nickname: string;
        optiIdEnabled?: boolean;
        productId: string;
        productName: string;
        region?: string;
        roles: InstanceRole[];
        technicalContactEmail?: string;
        technicalContactName?: string;
    }) {
        this.genAIEnabled = genAIEnabled;
        this.instanceId = instanceId;
        this.instanceName = instanceName;
        this.navigationUrl = navigationUrl;
        this.nickname = nickname;
        this.optiIdEnabled = optiIdEnabled;
        this.productId = productId;
        this.productName = productName;
        this.region = region;
        this.roles = roles;
        this.technicalContactEmail = technicalContactEmail;
        this.technicalContactName = technicalContactName;
    }

    genAIEnabled?: boolean;
    instanceId: string;
    instanceName: string;
    navigationUrl: string | undefined;
    nickname: string | null | undefined;
    optiIdEnabled?: boolean;
    productId: string;
    productName: string;
    region?: string;
    roles: InstanceRole[];
    technicalContactEmail?: string;
    technicalContactName?: string;
}
